module.exports = __webpack_public_path__ + "media/icons/delete@2x-b9af8ac0.png";